import Vue from 'vue'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { get as lodashGet } from 'lodash'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import { FACEBOOK_CLIENT_ID, INSTAGRAM_CLIENT_ID } from "@/utils/constants";
import 'vue-progress-path/dist/vue-progress-path.css';
import VueProgress from 'vue-progress-path';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.use(VueProgress, {
    defaultShape: 'line',
})

Vue.component('v-select', vSelect)

Vue.use(plugin)
Vue.use(VueMeta)
Vue.use(PortalVue)
Vue.use(VueToast, {
  position: 'top'
})

var filter = function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

InertiaProgress.init({
  // The delay after which the progress bar will
  // appear during navigation, in milliseconds.
  delay: 250,

  // The color of the progress bar.
  color: '#5BD9A4',
})

/**
 * Acces Ziggy routes from Vue
 * @see https://github.com/tighten/ziggy
 */
Vue.prototype.$route = (...args) => route(...args)

/**
 * Safely access deep nested objects keys
 * @see https://lodash.com/docs/4.17.15#get
 */
Vue.prototype.$get = lodashGet

const el = document.getElementById('app')

window.fbAsyncInit = function () {
  FB.init({
    appId: FACEBOOK_CLIENT_ID,
    cookie: true,
    xfbml: true,
    version: 'v10.0'
  });

  FB.AppEvents.logPageView();

};

(function (d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) { return; }
  js = d.createElement(s); js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} | Tithe.ly Media` : 'Tithe.ly Media'
  },

  render: h => h(App, {
    props: {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: name => require(`./views/${name}`).default,
    },
  }),

  mounted() {
   setTimeout(() => {
    let user = this.$page.props.user;

    if(window.pendo && user) {
      pendo.initialize({
        visitor: {
            id:              user.id,
            email:           user.email,
            adminName:       user.given_name + ' ' + user.family_name,
            churchName:      user.organization_id,
        },
      });
    }
   }, 500);

    this.$inertia.on('navigate', event => {
      if (!window.dataLayer) {
        return
      }

      window.dataLayer.push({
        event: 'pageView',
        url: event.target.URL,
      })
    });
  }
}).$mount(el)
